import { render, staticRenderFns } from "./BarEdpByPrescripteurChart.vue?vue&type=template&id=50df2824&"
import script from "./BarEdpByPrescripteurChart.vue?vue&type=script&lang=ts&"
export * from "./BarEdpByPrescripteurChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports